<template>
  <div class="progress">
    <div class="text">
      {{ $store.state.currentStep }}/{{ $store.state.maxStep-1 }}
    </div>
    <div class="bar">
      <div class="barinner">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Progress',
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.progress {
  display: flex;
  margin: 50px auto 20px auto;
  width: 70vw;
  align-items: center;
}
.text {
  flex-basis: 100px;
  font-size: 16px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
}
.bar {
  flex-basis: calc(100% - 100px);
  height: 15px;
  background-color: #c0e2e3;
  display: flex;
}
.barinner {
  background-color: #007b8a;
  /*transition: flex-basis 200ms linear;*/
}
@media screen and (max-width: 767px) {
  .progress {
    margin: 20px auto 10px auto;
    width: calc(100vw - 60px);
  }
}
</style>
